import React from "react";
import PropTypes from "prop-types";

import TextField from "@mui/material/TextField";


const PriceCentField = (props) => {
    const {value, onChange = f => f, ...TextFieldProps} = props;

    // The number of fractional digit typed by the user. It is important because
    // when formatting the price cent is important to know how many fractional digits
    // the user typed to produce the same result.
    const [fractionalDigits, setFractionalDigits] = React.useState(2);

    // from priceCent to price
    const formatPrice = (value) => {
        const priceCent = Number.parseInt(value);
        if (Number.isFinite(priceCent)) {
            const formattedPriceCent = priceCent / 100;
            return formattedPriceCent % 1 === 0 ? formattedPriceCent : formattedPriceCent.toFixed(fractionalDigits);
        }
        return '';
    }

    // from price to priceCent
    const parsePrice = (value) => {
        const price = Number.parseFloat(value);
        if (Number.isFinite(price)) {
            return price * 100;
        }
        return null;
    }

    const handlePriceChange = (e) => {
        const value = e.target.value;
        const price = parseFloat(e.target.value);
        // check if value is a number
        if ( Number.isFinite(price)) {
            const fractionalDigits = Math.min(value.toString().split('.')[1]?.length || 0, 2);
            setFractionalDigits(fractionalDigits);
            onChange(parsePrice(price));
        }else{
            onChange(null);
            setFractionalDigits(Math.min(fractionalDigits, 2));
        }
    }

    return <TextField type="number"
                      placeholder="----.--"
                      variant="standard"
                      label="Prezzo"
                      value={formatPrice(value)}
                      onChange={handlePriceChange}
                      {...TextFieldProps}
    />
}

PriceCentField.propTypes = {
    props: PropTypes.object,  // any properties of a TextField component
}

export default PriceCentField;